"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const Label_1 = require("../Label");
exports.ComboBox = (props) => {
    function onChange(e) {
        var value = e.target.value;
        if (typeof props.value === "number")
            value = parseFloat(value);
        props.onChange(value);
    }
    function renderCombo() {
        if (props.data.length > 0) {
            const fieldClassName = classnames_1.default({
                'col': !props.fieldSize,
                [`col-md-${props.fieldSize}`]: props.fieldSize,
            });
            return (react_1.default.createElement(__1.Col, { className: fieldClassName },
                react_1.default.createElement("select", { id: props.name, name: props.name, className: "form-control", onChange: onChange, value: props.value, disabled: props.disabled },
                    props.emptyText && react_1.default.createElement("option", { value: "" }, props.emptyText),
                    props.data.map((opcao, index) => {
                        if (props.memberValue && props.memberName)
                            return (react_1.default.createElement("option", { key: index, value: opcao[props.memberValue] }, opcao[props.memberName]));
                        else
                            return (react_1.default.createElement("option", { key: index, value: opcao }, opcao));
                    }))));
        }
        else {
            return null;
        }
    }
    const containerClassName = classnames_1.default("form-group", {
        "col-md": props.inline,
    });
    return (react_1.default.createElement("div", { className: containerClassName },
        react_1.default.createElement(__1.Row, null,
            props.title && react_1.default.createElement(Label_1.Label, { value: props.title, size: props.labelSize }),
            renderCombo())));
};
